import { PostSource, PostStatus } from './constants';
import type { BusinessUI } from '../business/types';

export type ClickOut = {
    url: string;
    target: 'button';
    text: string;
};

export enum ReactionState {
    LIKE = 'like',
    DISLIKE = 'dislike',
    NONE = 'none',
}

export type ContentUI =
    | {
          id: string;
          type: 'image';
          media: Inspire.Image[];
      }
    | {
          id: string;
          type: 'video';
          media: Inspire.Video[];
      };

export interface PriceUI {
    currency: string;
    integerPart: number;
    fractionalPart?: number;
}

export interface ProductItemUI {
    id: string;
    url: string;
    title: string;
    content: ContentUI[];
    priceInfo: PriceUI;
    oldPriceInfo: PriceUI;
}

export interface ProductsUI {
    items: ProductItemUI[];
    buttonTitle: string;
    businessButtonTitle: string;
    description: string;
    title: string;
}

export interface PostUI {
    id: string;
    url: string;
    shareUrl: string;
    views: number;
    likes: number;
    reactionState: ReactionState;
    saved: boolean;
    business: BusinessUI;
    text: string;
    clickouts: ClickOut[];
    createdAt: string;
    status: PostStatus;
    source: PostSource;
    djRequestId?: string;
    content: ContentUI[];
    products: ProductsUI;
}

export type PostPersistenceMediaUI =
    | {
          id: string;
          url: string;
          width: number;
          height: number;
          type: 'image';
      }
    | {
          id: string;
          url: string;
          width: number;
          height: number;
          firstFrameUrl?: string;
          type: 'video';
      };

export interface PostPersistenceUI {
    id?: string;
    businessId: string;
    text: string;
    site?: string;
    status?: PostStatus;
    source?: PostSource;
    media: PostPersistenceMediaUI[];
    products: ProductsUI;
}

export interface PostStatItemUI {
    value: number;
    display: string;
}

export interface PostStatUI {
    coverage?: {
        total: PostStatItemUI;
        subscribers: PostStatItemUI;
        notsubscribers: PostStatItemUI;
    };
    involved?: {
        total: PostStatItemUI;
        subscribers: PostStatItemUI;
        notsubscribers: PostStatItemUI;
    };
    shows?: {
        total: PostStatItemUI;
        subscribers: PostStatItemUI;
        notsubscribers: PostStatItemUI;
    };
    subscribers?: {
        total: PostStatItemUI;
        subscribed: PostStatItemUI;
        unsubscribed: PostStatItemUI;
    };
    interactions?: {
        total: PostStatItemUI;
        clicks: PostStatItemUI;
        likes: PostStatItemUI;
        shares: PostStatItemUI;
        saves: PostStatItemUI;
    };
}
